import { usersReducer, middleware as UsersMiddleware } from './Users'
import { creativesReducer, middleware as CreativesMiddleware } from './Creatives'
import { clockReducer, middleware as ClockMiddleware } from './Clock'
import { newsReducer, middleware as NewsMiddleware } from './News'
import { backendReducer, middleware as BackendMiddleware } from './Backend'
import { settingsReducer, middleware as SettingsMiddleware } from './Settings'
import { toasterReducer, middleware as ToasterMiddleware } from './Toaster'
import { loadingBarReducer, middleware as LoadingBarMiddleware } from './LoadingBar'
import {
    launchProgressBarReducer,
    middleware as LaunchProgressBarMiddleware,
} from './LaunchProgressBar'
import { serverMenuReducer, middleware as ServerMenuMiddleware } from './ServerMenu'
import { syncReducer, middleware as SyncMiddleware } from './Sync'
import { commonTextsReducer, middleware as CommonTextsMiddleware } from './CommonTexts'
import { steamReducer, middleware as SteamMiddleware } from './Steam'
import { profileSelectorReducer, middleware as ProfileSelectorMiddleware } from './ProfileSelector'
import { eulaReducer, middleware as EulaMiddleware } from './Eula'

export const featureReducers = {
    usersReducer,
    creativesReducer,
    clockReducer,
    newsReducer,
    settingsReducer,
    backendReducer,
    toasterReducer,
    loadingBarReducer,
    launchProgressBarReducer,
    serverMenuReducer,
    syncReducer,
    commonTextsReducer,
    steamReducer,
    profileSelectorReducer,
    eulaReducer,
}

export const featureMiddlewares = [
    UsersMiddleware,
    CreativesMiddleware,
    ClockMiddleware,
    NewsMiddleware,
    LoadingBarMiddleware,
    SettingsMiddleware,
    ToasterMiddleware,
    BackendMiddleware,
    LaunchProgressBarMiddleware,
    SyncMiddleware,
    ServerMenuMiddleware,
    CommonTextsMiddleware,
    SteamMiddleware,
    ProfileSelectorMiddleware,
    EulaMiddleware,
]



// WEBPACK FOOTER //
// ./src/features/index.js